import { render, staticRenderFns } from "./CustomizeMetalU.vue?vue&type=template&id=c46a8e2c&scoped=true"
import script from "./CustomizeMetalU.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalU.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalU.vue?vue&type=style&index=0&id=c46a8e2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46a8e2c",
  null
  
)

export default component.exports